import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {TopBarModel} from "../../shared/models/ui/top-bar.model";

@Component({
    selector: 'bergh-top-bar',
    templateUrl: './top-bar.component.html',
    styleUrls: ['./top-bar.component.scss'],
    standalone: false
})
export class TopBarComponent implements OnInit {
  status = true
  @Input() data: TopBarModel;
  @Input() type;
  @Input() returnStatus: boolean;
  @Output() clicked: EventEmitter<{index: number, status: boolean}> = new EventEmitter();
  public flag = 'NOT Loaded';
  constructor(
  ) { }

  ngOnInit(): void {
   }

  public changeState(index) {
    this.status = this.returnStatus === undefined ? !this.status : !this.returnStatus
    const DATA = {index: index, status: this.status}
    this.clicked.emit(DATA);
  }
}
